import TextTag from "../../components/Tag";
import "./index.css";

const SECTIONS = [
  {
    id: "acceptance",
    title: "Acceptance of terms",
    content: `By downloading or using Habitime, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use the app. Your continued use of Habitime constitutes your acceptance of any updates or changes to these terms.`,
  },
  {
    id: "use",
    title: "Use of the app",
    content: `Habitime is intended for personal, non-commercial use. You agree to use the app only for its intended purpose — tracking your daily activities and building better habits. You must not attempt to reverse engineer, modify, distribute, or exploit any part of the app. We reserve the right to discontinue the app or any of its features at any time without notice.`,
  },
  {
    id: "ip",
    title: "Intellectual property",
    content: `All content, design, code, and assets within Habitime are the intellectual property of Habitime and its creators unless otherwise stated. The Habitime name, logo, and branding may not be used without prior written permission. Open source libraries used within the app remain subject to their respective licenses.`,
  },
  {
    id: "disclaimer",
    title: "Disclaimers & liability",
    content: `Habitime is provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. We do not guarantee that the app will be error-free, uninterrupted, or free of bugs. Since all data is stored locally on your device, we are not responsible for any data loss resulting from app deletion, device failure, or any other circumstance. Use the app at your own discretion.`,
  },
  {
    id: "changes",
    title: "Changes to terms",
    content: `We may update these Terms of Use from time to time. When we do, we will update the date at the bottom of this page. We encourage you to review this page periodically. Continued use of the app after any changes constitutes your acceptance of the new terms.`,
  },
  {
    id: "contact",
    title: "Contact information",
    content: `If you have any questions or concerns about these terms, please reach out to us at support@habitime.app. We aim to respond to all enquiries within 5 business days.`,
  },
];

const TermsPage = () => {
  return (
    <div className="terms-page">
      <div className="terms-page__hero">
        <TextTag text="Terms of use" />
        <h1 className="terms-page__title">
          Simple terms for a <span>simple app</span>
        </h1>
        <p className="terms-page__sub">
          These terms govern your use of Habitime. We've kept them as clear and
          straightforward as possible. Last updated January 2026.
        </p>
      </div>

      <div className="terms-page__body">
        <div className="terms-page__sidebar">
          <div className="terms-page__nav">
            {SECTIONS.map(({ id, title }) => (
              <a key={id} href={`#${id}`} className="terms-page__nav-link">
                {title}
              </a>
            ))}
          </div>
        </div>

        <div className="terms-page__content">
          {SECTIONS.map(({ id, title, content }, index) => (
            <div key={id} id={id} className="terms-page__section">
              <div className="terms-page__section-header">
                <h2 className="terms-page__section-title">{title}</h2>
              </div>
              <p className="terms-page__section-body">{content}</p>
            </div>
          ))}

          <div className="terms-page__footer-note">
            <p>Last updated: January 2026</p>
            <p>
              These terms apply to all versions of Habitime on iOS and Android.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
